// В РАЗРАБОТКЕ
// import { TabType } from "../UniversalEditModal"; 

// interface Props {
//   sider: TabType;
//   label: string;
//   activeTab: TabType;
//   changeActiveTab: (s: TabType) => void;
// }

interface Props {
  sider: string;
  label: string;
  activeTab: string;
  changeActiveTab: (s: string) => void;
}

export default function TabButton({
  sider,
  label,
  activeTab,
  changeActiveTab,
}: Props) {
  return (
    <button
      className={`universaleditmodal-left-sidebar-button ${
        activeTab === sider ? "active" : ""
      }`}
      onClick={() => changeActiveTab(sider)}
    >
      {label}
    </button>
  );
}
